/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const School = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 73 59">
            <path fillRule="evenodd" clipRule="evenodd" d="M24.0542 29.0231V25.0691L37.0388 17.9326L50.0798 25.0691V29.0231H69.3042V55.5427H3.85059V29.0231H24.0542Z" fill="currentColor" />
            <path d="M73 54.918H0V58.5042H73V54.918Z" fill="currentColor" />
            <path d="M64.8882 38.7036H57.791V45.9801H64.8882V38.7036Z" fill="white" />
            <path d="M26.3619 38.7036H19.2646V45.9801H26.3619V38.7036Z" fill="white" />
            <path d="M53.7359 38.7036H46.6387V45.9801H53.7359V38.7036Z" fill="white" />
            <path d="M15.2095 38.7036H8.1123V45.9801H15.2095V38.7036Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M24.0547 22.9892L37.0516 15.6116L50.0802 22.9892V19.2862L37.0516 12.1265L24.0547 19.2862V22.9892Z" fill="currentColor" />
            <path d="M46.0742 1.38379H36.5V7.77743H46.0742V1.38379Z" fill="currentColor" />
            <path d="M36.3232 35.6688C40.0657 35.6688 43.0996 32.5332 43.0996 28.6652C43.0996 24.7972 40.0657 21.6616 36.3232 21.6616C32.5808 21.6616 29.5469 24.7972 29.5469 28.6652C29.5469 32.5332 32.5808 35.6688 36.3232 35.6688Z" fill="white" />
            <path d="M37.0249 24.2559V29.6387H31.8066" stroke="currentColor" strokeWidth="2.53472" strokeLinecap="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M32.4434 43.7604C32.8558 41.8534 34.3232 40.8999 36.8454 40.8999C39.3677 40.8999 40.8351 41.8534 41.2475 43.7604V55.4547H32.4434V43.7604Z" fill="white" />
            <path d="M38.4928 1.92172C38.4928 1.41267 38.0802 1 37.5711 1C37.0621 1 36.6494 1.41267 36.6494 1.92172V11.9471C36.6494 12.4562 37.0621 12.8688 37.5711 12.8688C38.0802 12.8688 38.4928 12.4562 38.4928 11.9471V1.92172Z" fill="currentColor" stroke="currentColor" strokeWidth="1.31172" />
        </SvgIcon>
    );
};

School.defaultProps = { className: '' };

School.propTypes = { className: PropTypes.string };

export default School;
